import { useItem } from "../../../fetch/fetch.item.ts";
import { EMPTY_ITEM } from "../../../const/typeDefault/Item.ts";
import ErrMessage from "../../core/ErrMessage.tsx";
import { useAuthToken } from "../../../hooks/useAuthToken.ts";
import { ReactNode } from "react";

const IfItemOwner = ({
  itemId,
  children,
  fallback,
}: {
  itemId: string;
  children?: ReactNode;
  fallback?: ReactNode;
}) => {
  const authToken = useAuthToken();
  const { item, isLoading, isError } = useItem(itemId, EMPTY_ITEM);
  if (isLoading) return fallback;
  if (isError) return <ErrMessage message={isError} />;
  if (authToken.status !== "ok" || authToken.authId !== item.ownerId)
    return fallback;
  return children;
};
export default IfItemOwner;
